import React from "react";
import { Link, useLocation } from "react-router-dom";
import AuthScreenShell from "../../components/AuthScreenShell";

export default function VerifyEmail() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const email = params.get("email");

  return (
    <AuthScreenShell>
      <div className="auth-screen__header space-y-2">
        <h2 className="auth-screen__title">Verify Email</h2>
        <p className="auth-screen__desc">
          Confirm your email address to
          <br />
          complete signup
        </p>
      </div>

      <div className="auth-alert auth-alert--success shadow-[var(--card-shadow)]">
        {email
          ? `A verification link has been sent to ${email}.`
          : "A verification link has been sent to your email."}
      </div>

      <Link
        className="auth-screen__forgot inline-flex items-center justify-center transition-transform duration-200 hover:-translate-y-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--nba-green)] focus-visible:ring-offset-2"
        to="/login"
      >
        Continue to Login
      </Link>
    </AuthScreenShell>
  );
}
